import { Box } from "@material-ui/core"
import { styled } from "@mui/material/styles"

export const ContainerModal = styled(Box)`
  position: absolute;
  border-radius: 8px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-height: 80vh;
  box-shadow: 24;
  background: #f8f8fb;
`

export const ContentModal = styled(Box)`
  padding: 32px;
  max-height: calc(80vh - 140px);
  overflow-y: auto;
`

export const HeaderModal = styled(Box)`
  height: 70px;
  padding-left: 32px;
  padding-right: 32px;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  background: white;
  display: flex;
  align-items: center;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`

export const TitleModal = styled(Box)`
  font-size: 16px;
  font-weight: 500;
`

export const FooterModal = styled(Box)`
  height: 70px;
  padding: 16px 32px 16px 32px;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  background: white;
  display: flex;
  justify-content: flex-end;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`
